import React from 'react';
import classnames from 'classnames';

import { DeleteButton } from '@components/Button';

import { addDeactivatedString } from '@utils/AppUtil';
import { fromISOStringToDateTimeString } from '@utils/CalendarUtil';

import { IDisplayEditAttachment } from './AttachmentsEditModal';

import './style.scss';

export interface IAttachmentDataProps {
  attachment: IDisplayEditAttachment;
  actionButtons?: JSX.Element[];
  deleteAction?: (e: React.SyntheticEvent<any>, imageToBeDeletedIndex: number) => void;
  index: number;
  mode: TEditAttachmentModes;
}

const AttachmentData: React.FunctionComponent<IAttachmentDataProps> = ({
  attachment,
  index,
  actionButtons,
  deleteAction,
  mode,
}) => {
  const actionButtonsFromProps = actionButtons || [];
  const allActionButtons = [
    ...actionButtonsFromProps,
    <DeleteButton key={10} onClick={(attachmentIndex) => deleteAction(null, attachmentIndex)} />,
  ];

  return (
    <>
      {attachment && (
        <div className={classnames('attachments-edit__saved-summary')}>
          <div className={classnames('attachments-edit__upload-details')}>
            {attachment.createdAt && (
              <div>
                {`Uploaded on ${fromISOStringToDateTimeString(attachment.createdAt)} by ${
                  attachment.createdBy
                    ? `${addDeactivatedString(
                        `${attachment.createdBy.firstName} ${attachment.createdBy.lastName}`,
                        attachment.createdBy?.isActive
                      )}`
                    : ''
                }`}
              </div>
            )}
            <div>{`${attachment.fileName} (${attachment.fileSize})`}</div>
          </div>
          {mode !== TEditAttachmentModes.READ_ONLY &&
            allActionButtons.map((actionButton) =>
              React.cloneElement(actionButton, {
                ...actionButton.props,
                key: index,
                onClick: (e) => actionButton.props.onClick(index),
              })
            )}
        </div>
      )}
    </>
  );
};

export default AttachmentData;
